import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsStartedPayload } from '../payloads/projectsStartedPayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildProjectsStartedInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsStartedPayload(payload);
  const { projects_started } = parsedPayload.data.attributes.aggregate;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: projects_started.current ?? 0,
          trend: projects_started.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
